import { ApiService } from "@/api";

export const updateGroupMember = (
  groupId: string,
  data: {
    remove: string[];
    append: string[];
  }
) => {
  return ApiService.baseAction(
    `group/${groupId}/update_member`,
    {
      data,
    },
    "post"
  );
};
